import { strictCollectMemberUsage } from "@next-core/utils/storyboard";
var EXPRESSION_PREFIX_REG = /^<%=?\s/;
var EXPRESSION_SUFFIX_REG = /\s%>$/;

/**
 * @param value The trimmed string content
 * @returns if the value is a valid expression
 */
function isExpression(value) {
  return EXPRESSION_PREFIX_REG.test(value) && EXPRESSION_SUFFIX_REG.test(value);
}
export function parseDataSource(data) {
  if (typeof data !== "string") {
    return {
      isString: false
    };
  }
  var expression;
  var expr = data.trim();
  if (isExpression(expr)) {
    expression = expr.replace(EXPRESSION_PREFIX_REG, "").replace(EXPRESSION_SUFFIX_REG, "").trim();
  } else {
    // eslint-disable-next-line no-console
    console.warn("Invalid expression:", JSON.stringify(data));
    expression = "null";
  }
  var usedContexts = strictCollectMemberUsage(data, "CTX");
  return {
    isString: true,
    embedded: data,
    expression: expression,
    usedContexts: usedContexts
  };
}
//# sourceMappingURL=expressions.js.map